// extracted by mini-css-extract-plugin
module.exports = {"imageCardContainer":"DygYj","tagContainer":"_34kR3","imgArea":"fg-Tc","textArea":"_345tn","content":"_3l4Is","buttonContainer":"_1mVVj"};